import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-fav-video-item-add-video',
  templateUrl: './fav-video-item-add-video.component.html',
  styleUrls: ['./fav-video-item-add-video.component.scss']
})
export class FavVideoItemAddVideoComponent {
  @Input() video:any;
  @Input() modalid:any;
  @Input() videosList:any;
  @Input() selectedPlaylist:any;
  @Output() newItemEvent = new EventEmitter<string>();
  @Output() addRemoveToPlaylist = new EventEmitter<any>();
  videoDetails:any;
  addingToList=0;
  removingFromList=0;

  constructor(public webApi: WebapiService, private toastrService: ToastrService) {
  }

  
  openDetails(id: Number,modalid:any){
    this.videoDetails = '';
    this.videoDetails = this.videosList.filter(function(video:any) {
      return video.id == id;
    })[0]; 
    
    this.newItemEvent.emit(this.videoDetails);
    
    if(this.videoDetails.allowed==0){
      setTimeout(()=>{
        if(document.getElementById('videos-locked-popup-modal')){
          var myModal = new bootstrap.Modal(document.getElementById('videos-locked-popup-modal'), {
            keyboard: true
          })
          myModal.show()
          //console.log('show-new-vids modal')
        }
      },300)
      return 
    }

    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }
  
  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  checkInPlaylist(playlistid,video){
    if(!video.playlists) return false;
    let found =video.playlists.filter((item)=>{ return item.favourite_list_id==playlistid})
    return found.length>0?true:false
  }

  addToPlaylist(playlist,video,type="add") {
      this.addingToList=video.id;
      this.removingFromList=video.id
      let params = {'playlist_id':playlist,'video_id':video.id};
      this.webApi.addToPlaylist(params).subscribe((data: any) => {
        if (data.success) {
          if(!video.playlists) video.playlists=[];
          if(type=="add"){
            video.playlists.push({"favourite_list_id":playlist})
            let data = {type:'add',playlist:playlist}
            this.addRemoveToPlaylist.emit(data);
            console.log('sdsd')
          }else{
            video.playlists=video.playlists.filter((item)=>{ return item.favourite_list_id!=playlist})
            let data = {type:'remove',playlist:playlist}
            this.addRemoveToPlaylist.emit(data);
          }
					this.toastrService.success(data.message);
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.removingFromList=0;
        this.addingToList=0;
      },
      error => {
        this.toastrService.error("unable to handle response");
      });
  }
  
  
}
